// extracted by mini-css-extract-plugin
export default {"breadcrumbs_container":"breadcrumbs_container___GoZFQ","breadcrumbs":"breadcrumbs___xPkad","active":"active___v1yUX"};